import React, { useEffect, useMemo, useState } from 'react';
import '../assets/styles/components/MenuLateral.scss';
import logo from "../assets/images/logo.png";
import logoSmall from "../assets/images/logo-small.png";
import config from "../config/config.js";
import { useNavigate, useLocation } from "react-router-dom";
import Perfil from "./Header/Perfil.js";
import layout from '../lib/layout';
import tools from '../lib/tools';

export default function MenuLateral({ open, openMenu }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    layout.setMenuOpen(open);
  }, [open]);

  useEffect(() => {
    const scrollTela = () => {
      document.body.style.overflow =
        (document.body.offsetWidth <= 1024 && layout.menuOpen) ? "hidden" : "auto";
    };
    scrollTela();
    window.addEventListener('resize', scrollTela);
    return () => window.removeEventListener('resize', scrollTela);
  }, []);

  const menu = layout.menu;

  const matchPathLoose = (itemPath, currentPath) => {
    const a = (itemPath || '/').replace(/\/+$/, '') || '/';
    const b = (currentPath || '/').replace(/\/+$/, '') || '/';
    if (a === '/') return b === '/';
    return b === a || b.startsWith(a + '/');
  };

  const isItemActive = React.useCallback((item) => {
    if (matchPathLoose(item.id, pathname)) return true;

    if (item.sub?.length) {
      return item.sub.some((sub) => matchPathLoose(sub.id, pathname));
    }
    return false;
  }, [pathname]);

  const computedOpenByRoute = useMemo(() => {
    const acc = {};
    for (const it of menu) {
      if (it.sub?.length) acc[it.id] = isItemActive(it);
    }
    return acc;
  }, [menu, isItemActive]);

  const [openStates, setOpenStates] = useState(computedOpenByRoute);
  useEffect(() => {
    setOpenStates((prev) => ({ ...prev, ...computedOpenByRoute }));
  }, [computedOpenByRoute]);

  const toggleOpenState = (itemId) => {
    setOpenStates((prev) => ({ ...prev, [itemId]: !prev[itemId] }));
  };

  const openItem = (e, item) => {
    e.preventDefault();

    if (item.sub && item.sub.length > 0) {
      toggleOpenState(item.id);
      return;
    }

    navigate(item.id);
  };

  const user = config.user;

  return (
    <div className={`menu-lateral overflow-auto scrollfit ${open ? 'open' : 'close'}`}>
      <div className="container-logo">
        <img
          src={logo}
          className="logo-img pointer"
          alt="logo"
          onClick={() => tools.openURL("/")}
        />
        <i
          className="icon icon-cross-small pointer white i-35"
          onClick={() => openMenu(false)}
        />
      </div>

      <img
        src={logoSmall}
        className="logo-img-small pointer"
        alt="logo"
        onClick={() => tools.openURL("/")}
      />

      <Perfil user={user} />

      <nav>
        <ul>
          {menu.map((item) => {
            if (
              item?.permission &&
              (!config.temPermissao(item.permission) &&
                item.exceptionForUserId !== parseInt(user?.id))
            ) {
              return null;
            }

            const active = isItemActive(item);
            const sectionOpen = !!(openStates[item.id] || active);

            return (
              <li className={`${active ? 'is-active' : ''}`} key={item.id} title={item.label}>
                <span className="pointer" onClick={(e) => openItem(e, item)}>
                  <i className={`icon ${item.icon} white i-20`} />
                  <label className="pointer">{item.label}</label>
                </span>

                {item.sub?.length > 0 && sectionOpen && (
                  <ul className="sub">
                    {item.sub.map((sub) => {
                      if (
                        sub?.permission &&
                        (!config.temPermissao(sub.permission) &&
                          sub.exceptionForUserId !== parseInt(user?.id))
                      ) {
                        return null;
                      }
                      const subActive = matchPathLoose(sub.id, pathname);
                      return (
                        <li
                          className={`${sub.id} ${subActive ? 'is-active' : ''} f600-16`}
                          key={sub.id}
                          title={sub.label}
                          style={{ height: '60px' }}
                        >
                          <div />
                          <span className="pointer" onClick={(e) => openItem(e, sub)}>
                            <i className={`icon ${sub.icon} white i-20`} style={{ cursor: 'pointer' }} />
                            <label className="pointer">{sub.label}</label>
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </nav>

      <div className="w-100 text-center mt-25" title="Versão do sistema" id="version">
        <span className="f400-12 color-white">
          v{
            config.isSaastoUser()
              ? (
                <a
                  href="https://phpenterprise.atlassian.net/wiki/external/NzlhM2M0MzhkOTNiNDUzZGFjZjVkZGE3NmIyOWJkZGU"
                  rel="noreferrer"
                  target="_blank"
                >
                  {config.release}
                </a>
              )
              : config.release
          }
        </span>
      </div>
    </div>
  );
}
